// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv[data-v-56bdccad]{\n  text-align: center;\n}\nh1[data-v-56bdccad]{\n  font-size: 10rem;\n}\nP[data-v-56bdccad] {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
